import { tv } from 'tailwind-variants';

export const styles = tv({
  base: `
    bg-[rgba(255,255,255,0.1)]
    p-6
  `,
});
